import { AuditColumnModel, StatusModel } from '../general';

export class Template {
  csvUrl!: string;
  _id!: string;
  templateId!: string;
  description!: string;
  payloadType: string;
  createdDate!: string;
  modifiedDate!: string;
  tenantName!: string;
  tenantId: string;
  payloadSchema: object;
  templateName: string;
  batchesCount: number;
  payloadSize: number;
  published!: boolean;
}

export interface PatchData {
  csvUrl?: string;
  isClone?: boolean;
  isEdit?: boolean;
  sampledFields?: SampledKeysArray[];
  simulationData?: SimulationData[];
  templateDetails?: TemplateDetails[];
}

export interface TemplateDetails {
  description: string;
  payloadSchema: object;
  payloadType: string;
  selectedTenant: TenantDetails;
  templateId: string;
  templateName: string;
}

export interface TenantDetails {
  _id: string;
  name: string;
  domain?: string;
  address?: Address;
  phone?: Phone;
  email?: string;
  secondaryEmail?: string;
  logo?: string;
  license?: License;
  appId?: string;
  poc?: PointOfContact[];
  status?: boolean;
  tenantStatus?: string;
  remarks?: string;
  metadata?: AuditColumnModel;
  __v?: number;
  clientId?: string;
}

export interface Address {
  lineOne: string;
  lineTwo: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export interface Phone {
  countryCode: string;
  number: string;
}

export interface License {
  type: string;
  key: string;
  startDate: string;
  endDate: string;
}

export interface PointOfContact {
  name: string;
  email: string;
  phone: Phone;
  _id: string;
}

export interface TransformedData {
  sampledFields: SampledKeysArray[];
  simulationData: SimulationData[];
}

export interface SimulationData {
  name: string;
  action?: boolean;
  isEdited?: boolean;
  sampling?: boolean;
  attributes: Attribute;
}

export interface Attribute {
  description: string;
  initialValue?: number;
  lowerThreshold?: number;
  name: string;
  noOfDecimals?: number;
  fieldLength?: number;
  noiseLevel?: number;
  seasonalityAmplitude?: number;
  trendNoiseLevel?: number;
  trendSlope?: number;
  type?: string;
  upperThreshold?: number;
  carryForward?: boolean;
  cumulative?: boolean;
  startValue?: number;
  endValue?: number;
  stepValue?: number;
  order?: string;
  columnName?: string;
  format?: string;
  deviceField?: string;
  timeZone?: string;
  behaviour?: string;
}

export interface Payload {
  published?: boolean;
  templateName?: string;
  templateId?: string;
  payloadType?: string;
  description?: string;
  payloadSchema?: object;
  fieldMappings?: FieldMapping[];
  csvUrl?: string;
  sampledFields?: string[];
}

export interface FieldMapping {
  key: string;
  name: string;
  description: string;
  order: string;
  sampling?: boolean;
  attributes: any;
}

export interface TableData {
  key: string;
  name: string;
  description: string;
  type: string;
  behaviour?: string;
  configurations: any;
}

export interface TemplateModel {
  _id: string;
  csvUrl?: string;
  published?: boolean;
  templateId: string;
  templateName: string;
  payloadType: string;
  description: string;
  createdDate: string;
  modifiedDate: string | null;
  tenantName: string;
  tenantId: string;
  payloadSchema: object;
  status?: StatusModel;
}

export interface SampledKeysArray {
  key: string;
  sampling?: boolean;
  disabled?: boolean;
}

export interface FieldsTableData {
  formFillStatus?: string;
  key: string;
  name: string;
  type: string;
  behaviour: string;
  cumulative: string;
  carryForward: string;
}